module.exports = __webpack_public_path__ + "static/m_2-95bb62f4afdd94afb6876f3edba90172.png";